import Vue from "vue"
import VueI18n from "vue-i18n"
import en from "./../lang/en.json"
import th from "./../lang/th.json"

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: "th",
    fallbackLocale: "en",
    messages: {
        th, en
    }
})
